import { createSelector } from 'reselect';

import { State } from './types';
import { isFollowUpQuestion } from './utils';

const selectState = (state: any): State => state.questionnaire;

export const selectQuestions = createSelector([selectState], (questionnaire: State) => questionnaire.questions);
export const selectCurrentSection = createSelector([selectState], (questionnaire: State) => questionnaire.currentSection);
export const selectEditedQuestionId = createSelector([selectState], (avatars: State) => avatars.editedQuestionId);
export const selectIsEditingAnyQuestion = createSelector(
  [selectState],
  (questionnaire: State) => questionnaire.editedQuestionId !== null
);
export const selectInitialQuestion = createSelector(
  [selectState, (_: State, questionId: string) => questionId],
  (state: State, questionId: string) => state.initialQuestions.find(question => question._id === questionId)
);

export const selectQuestionAnswers = createSelector(
  [selectState, (_: State, questionId: string | null) => questionId],
  (questionnaire: State, questionId) => {
    if (!questionnaire.questions) return [];
    if (!questionId) return [];

    const question = questionnaire.questions.find(question => question._id === questionId);
    return question ? question.answers : [];
  }
);

export const selectPossibleParentQuestions = createSelector(
  [selectState, (state: State, currentQuestion: string) => currentQuestion],
  (questionnaire: State, currentQuestionId) => {
    if (!questionnaire.questions) return [];

    const nonFollowUpQuestions = questionnaire.questions.filter(question => !isFollowUpQuestion(question));
    const nonFollowUpQuestionsWithoutCurrent = nonFollowUpQuestions.filter(
      question => question._id !== currentQuestionId
    );

    return nonFollowUpQuestionsWithoutCurrent;
  }
);

export const selectBlockingAnswers = createSelector([selectState], (questionnaire: State) => questionnaire.blockingAnswers);

export const selectIsBlockingAnswer = createSelector(
  [selectState, (_: State, answerId: string) => answerId],
  (questionnaire: State, answerId) => questionnaire.blockingAnswers.includes(answerId)
);
